const transformData = (data, params) => {
    const transformedData = {
        travelersCheck: [],
        firstTimeBlinkers: [],
        sevenDayWinners: [],
    };

    if (!data) {
        return transformedData;
    }

    Object.keys(transformedData).forEach((key) => {
        transformedData[key] = Array.isArray(data[key])
            ? data[key]
            : transformedData[key];
    });

    const { sevenDayWinners, firstTimeBlinkers, travelersCheck } = transformedData;

    return ({
        firstTimeBlinkers: firstTimeBlinkers.map(firstTimeBlinker => ({
            ...firstTimeBlinker,
            courseUid: +params.id,
            courseName: params.name,
        })),
        travelersCheck: travelersCheck.map(traveller => ({
            ...traveller,
            courseName: params.name,
        })),
        sevenDayWinners: sevenDayWinners.map(winner => ({
            ...winner,
            upcomingRace: {
                ...winner.upcomingRace,
                courseUid: +params.id,
                courseName: params.name,
            },
        })),
    });
};

export default transformData;



// WEBPACK FOOTER //
// ./src/js/course/signposts/transformData.js